import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllOccupancyTypeService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allOccupancyTypeService = useQuery({
    queryKey: [...CACHE_KEYS.OCCUPANCY_TYPE, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.OCCUPANCY_TYPE,
        searchParams: {
          page,
          "filter[name]": debouncedQuery,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allOccupancyTypeService },
    states: { searchQuery, setSearchQuery },
  };
};
